const routes = {
    onboarding: '/onboarding',
}

export default routes;